import { render } from "./AutocompleteTextInput.vue?vue&type=template&id=7c56a434&scoped=true&ts=true"
import script from "./AutocompleteTextInput.vue?vue&type=script&lang=ts"
export * from "./AutocompleteTextInput.vue?vue&type=script&lang=ts"

import "./autocomplete-input.scss?vue&type=style&index=0&id=7c56a434&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c56a434"]])

export default __exports__